import React from 'react'
import awaiting from '../assets/awaiting.png'

export default function MyAwaiting() {
  return (
    <div>
        <img src={awaiting} className="w-full h-full"/>
    </div>
  )
}
